import React from "react";
import { VehicleReportGrid } from "./vehicleReportGrid";
import {
    useVehicleReportData,
    VehicleReportData,
    VehicleReportOptionsMapping,
} from "../../../hooks/reporting/useVehicleReportData";
import { MainLayout } from "../../layout/mainLayout";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import { VehicleEventType } from "../../../models/vehicle/vehicleEventInfo";
import { VehicleReportFilters } from "../VehicleReportFilters";

const dataInitialized = (data: VehicleReportData) =>
    !!data.vehicles &&
    !!data.eventData &&
    !!data.eventData[VehicleEventType.Distance] &&
    !!data.eventData[VehicleEventType.TotalFuel];

export const VehiclesMain = () => {
    const data = useVehicleReportData(Object.keys(VehicleReportOptionsMapping), false);
    const initialized = dataInitialized(data);

    return (
        <MainLayout
            noContainer
            className="fluid"
            topComponent={
                <VehicleReportFilters
                    vehicles={data.presentVehicles}
                    hideEmployeeGroup
                />
            }
        >
            <>
                <LoadingIndicator loading={data.loading || !initialized} />
                {initialized && <VehicleReportGrid {...data} />}
            </>
        </MainLayout>
    );
};
